/* eslint no-await-in-loop: "off" */
async function polling(pollingFunction, context, delay) {
  let enabled = true;
  do {
    enabled = await pollingFunction(context);
    await new Promise(resolve => setTimeout(resolve, delay));
  } while (enabled !== false);
}
export default polling;
